import cx from "classnames";
import React from "react";
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import firebase from "../../utils/firebase";

type HeaderImageProps = {
  filename: string;
};

const HeaderImage: React.FC<HeaderImageProps> = ({
  filename,
}: HeaderImageProps): React.ReactElement | null => {
  const [imageSrc, setImageSrc] = React.useState<undefined | string>(undefined);

  const fetchImageSrc = React.useCallback((): void => {
    if (!firebase) return;
    // Fetch image src
    const storage = getStorage(firebase);
    const imageRef = ref(storage, `assets/${filename}.png`);
    getDownloadURL(imageRef)
      .then((src: string) => {
        setImageSrc(src);
        return null;
      })
      .catch((error) => {
        // Handle any errors
        console.error("Error fetching image:", error);
      });
  }, [filename]);

  // Set up auth listener and fetch image
  React.useEffect(() => {
    if (!firebase) return;

    // Also listen for auth changes
    const unsubscribe = getAuth(firebase).onAuthStateChanged((user) => {
      if (user) {
        fetchImageSrc();
      }
    });

    return () => unsubscribe();
  }, [fetchImageSrc]);

  return imageSrc ? (
    <img
      alt="Headshot"
      className={cx([
        "julia-website-header-image",
        "u-background-color-primary",
        "u-border-color-primary",
        "u-border-l",
        "u-margin-bottom-2xs",
        "u-margin-top-m",
      ])}
      src={imageSrc}
    />
  ) : null;
};

export default HeaderImage;
